export default __webpack_public_path__ + "static/media/it-solutions-provider.6857e8c9.png";